import {notification} from "antd";

export const Toast = (type, title, desc) => {

    if (typeof title !== 'string') {
        desc = "Network Error."
    }

    if (typeof desc !== 'string') {
        desc = "Network Error."
    }

    notification[type]({
        message: title,
        description: desc,
    });
};
